import { useState } from "react";
import { useTranslation } from "react-i18next";
import Steps from "components/Steps";
import MainLayout from "layouts/MainLayout";
import ProjectName from "components/Project/ProjectForm/ProjectName";
import { convertObjToArr } from "utils/handleObjects";
import { post } from "core/Api";
import ProjectPhoto from "components/Project/ProjectForm/ProjectPhoto";
import ProjectDescription from "components/Project/ProjectForm/ProjectDescription";
import ProjectLanguages from "components/Project/ProjectForm/ProjectLanguages";
import ProjectCategories from "components/Project/ProjectForm/ProjectCategories";
import ProjectTimePeriod from "components/Project/ProjectForm/ProjectTimePeriod";
import ProjectRoles from "components/Project/ProjectForm/ProjectRoles";
import { ProjectDto } from "common/dtos/ProjectDto";
import { useAppSelector } from "store/hooks";
import { useHistory } from "react-router-dom";
import routes from "core/Routes";

const steps = [
  "name",
  "photo",
  "description",
  "language",
  "category",
  "timePeriod",
  "members",
];

const ProjectCreate = () => {
  const { t } = useTranslation("forms");
  const history = useHistory();
  const userId = useAppSelector((state) => state.user.auth.userId);
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedLangs, setSelectedLangs] = useState<any>({});
  const [selectedCategories, setSelectedCategories] = useState<any>({});
  const [projectData, setProjectData] = useState<ProjectDto>({
    owner: "",
    title: "",
    description: "",
    languages: [],
    categories: [],
    roles: [],
    startDate: "",
    dueDate: "",
  });

  const onSubmit = async (e: any) => {
    e.preventDefault();

    const allData = {
      ...projectData,
      owner: userId,
      languages: convertObjToArr(selectedLangs),
      categories: convertObjToArr(selectedCategories),
    };

    try {
      const data = await post("/projects", allData);
      if (data._id) {
        history.push(routes.explore.root);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const renderCurrentForm = () => {
    switch (currentStep) {
      case 0:
        return (
          <ProjectName
            projectData={projectData}
            setProjectData={setProjectData}
          />
        );
      case 1:
        return (
          <ProjectPhoto
            projectData={projectData}
            setProjectData={setProjectData}
          />
        );
      case 2:
        return (
          <ProjectDescription
            projectData={projectData}
            setProjectData={setProjectData}
          />
        );
      case 3:
        return (
          <ProjectLanguages
            selected={selectedLangs}
            setSelected={setSelectedLangs}
          />
        );
      case 4:
        return (
          <ProjectCategories
            selected={selectedCategories}
            setSelected={setSelectedCategories}
          />
        );
      case 5:
        return (
          <ProjectTimePeriod
            projectData={projectData}
            setProjectData={setProjectData}
          />
        );
      case 6:
        return (
          <ProjectRoles
            projectData={projectData}
            setProjectData={setProjectData}
          />
        );
    }
  };

  return (
    <MainLayout heading={t("project:createProject")}>
      <Steps
        steps={steps}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        submitLabel={t("forms:completeRegistration")}
        onSubmit={onSubmit}
      >
        {renderCurrentForm()}
      </Steps>
    </MainLayout>
  );
};

export default ProjectCreate;
